import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService, CostaAppService, DateService } from '../../_services';
import { Reservation } from '../../_models';
import { Constants, SessionStoragerService } from '../../_utility';

@Component({
  standalone: false,
  selector: 'app-complete-reservation',
  templateUrl: './complete-reservation.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class CompleteReservationComponent {
  datasource: Reservation | null | undefined;
  public autologin: boolean = true;
  public phone_number: string = '5555';

  constructor(
    private auth: AuthService,
    private sStore: SessionStoragerService,
    private costaApp: CostaAppService,
    public dateService: DateService
  ) {
    this.autologin = this.sStore.getElement(Constants.Storager.AUTOLOGIN);
    let reservation = this.sStore.getElement(Constants.Storager.RESERVATION);
    let phone_number = this.sStore.getElement(Constants.Storager.PHONE_NUMBER);
    if (!!phone_number) {
      this.phone_number = phone_number;
    }
    if (reservation) {
      this.datasource = reservation;
    }
  }

  Close() {
    this.costaApp.close();
    if (!this.autologin) {
      this.auth.SignOut();
    }
  }
}
